import React from 'react';

export default {
	path: '/ownershipContract',
	components: () => [import(/* webpackChunkName: 'ownershipContract' */ './component')],
	render: ([OwnershipContract]) => <OwnershipContract />,
};
